const API_HOST = '';
const CDN_HOST = '';

// Auth
export const API_CREATE_SESSION = `${API_HOST}/panel/api/v1/spg/create/session`;
export const API_LOGIN = `${API_HOST}/panel/api/v1/spg/user/login`;
export const API_LOGOUT = `${API_HOST}/panel/api/v1/spg/user/signout`;
export const API_FORGOT_PASSWORD = `${API_HOST}/panel/api/v1/spg/pswrd/forgot`;
export const API_RESET_PASSWORD = `${API_HOST}/panel/api/v1/spg/pswrd/reset`;
export const API_MARK_USER_ACTIVE = `${API_HOST}/panel/api/v1/spg/upgrade/user/active`;
export const API_IS_LOGGED_IN = `${API_HOST}/panel/api/v1/spg/isLoggedin`;
export const API_GET_USER_PROFILE = `${API_HOST}/panel/api/v1/spg/user/profile`;
export const API_GET_ACCESSIBLE_ITEMS_FOR_USER = `${API_HOST}/panel/api/v1/spg/role/access`;

// User Management
export const API_GET_ALL_USERS = `${API_HOST}/panel/api/v1/spg/users/get/all`;
export const API_CREATE_USER = `${API_HOST}/panel/api/v1/spg/create/user`;
export const API_UPDATE_USER = `${API_HOST}/panel/api/v1/spg/update/user`;
export const API_CREATE_ADMIN_USER = `${API_HOST}/panel/api/v1/spg/create/admin/user`;
export const API_UPDATE_ADMIN_USER = `${API_HOST}/panel/api/v1/spg/update/admin/user`;
export const API_GET_ALL_USER_CHECKERS = `${API_HOST}/panel/api/v1/spg/users/get/all/checker`;
export const API_GET_ALL_USER_MAKERS = `${API_HOST}/panel/api/v1/spg/users/get/all/maker`;
export const API_UPDATE_INTENT = `${API_HOST}/panel/api/v1/spg/checker/intent/action`;

// Role Management
export const API_GET_ALL_ROLES = `${API_HOST}/panel/api/v1/spg/role/get/all`;
export const API_CREATE_ROLE = `${API_HOST}/panel/api/v1/spg/role/create`;
export const API_UPDATE_ROLE = `${API_HOST}/panel/api/v1/spg/role/update`;
export const API_GET_ALL_RESOURCE_PERMISSION_DETAILS = `${API_HOST}/panel/api/v1/spg/role/get/all/resource/permission`;
export const API_GET_ALL_ROLE_CHECKERS = `${API_HOST}/panel/api/v1/spg/role/get/all/checker/detail`;
export const API_GET_ALL_ROLE_MAKERS = `${API_HOST}/panel/api/v1/spg/role/get/all/maker/detail`;

// Merchant Onboard
export const API_FETCH_ENTITY = `${API_HOST}/panel/api/v1/spg/merchant/fetch/entity`;
export const API_FETCH_ENTITY_V2 = `${API_HOST}/panel/api/v1/spg/v2/merchant/fetch/entity`;
export const API_ENTITY_CREATE = `${API_HOST}/panel/api/v1/spg/merchant/entity/create`;
export const API_ENTITY_LIST = `${API_HOST}/panel/api/v1/spg/merchant/entity/list`;
export const API_ENTITY_LIST1 = `${API_HOST}/panel/api/v1/spg/v2/entity/list`;
export const API_SAVE_CONTINUE = `${API_HOST}/panel/api/v1/spg/merchant/save/continue`;
export const API_FORM_IN_PROCESS = `${API_HOST}/panel/api/v1/spg/merchant/form/inprocess`;
export const API_FORM_DETAILS = `${API_HOST}/panel/api/v1/spg/merchant/fetch/form/details`;
export const API_SECTION_DATA = `${API_HOST}/panel/api/v1/spg/merchant/section/date`;
export const API_HIERARCHY_LIST = `${API_HOST}/panel/api/v1/spg/merchant/entity/hierarchy`;
export const API_GET_STATIC_INFO = `${API_HOST}/panel/api/v1/spg/merchant/fetch/onboarding/static/info`;
export const API_GET_PAYMENT_MODES = `${API_HOST}/panel/api/v1/spg/merchant/available/payment/mode`;
export const API_GET_DEFAULT_ROUTING = `${API_HOST}/panel/api/v1/spg/v1/merchant/fetch/default/routing`;
export const API_GET_SURCHARGE_SLABS = `${API_HOST}/panel/api/v1/spg/merchant/surcharge/fetch/paymentslab`;
export const API_SUBMIT_FORM = `${API_HOST}/panel/api/v1/spg/merchant/submit`;
export const API_RETRY_FAILED_MERCHANT_FORM_BY_ID = `${API_HOST}/panel/api/v1/spg/merchant/retry/failed/form`;

// MLE
//export const APT_FETCH_MLE_LIST = `${API_HOST}/panel/api/v1/spg/merchant/fetch/entity`;
export const APT_FETCH_MLE_LIST = `${API_HOST}/panel/api/v1/spg/v2/merchant/fetch/entity`;
export const APT_CREATE_MLE = `${API_HOST}/panel/api/v1/spg/mle/onboarding`;
export const APT_UPDATE_MLE = `${API_HOST}/panel/api/v1/spg/mle/update`;

export const APT_FETCH_MLE_DETAILS = `${API_HOST}/panel/api/v1/spg/mle/details`;
export const APT_FETCH_MLE_DETAILS_PINCODE = `${API_HOST}/panel/api/v1/spg/mle/details/pincode`;

// BD onboarding new routes
export const API_FETCH_BD_INPROGRESS_MERCHANT = `${API_HOST}/panel/api/v1/spg/bd/inprogress`;
export const API_SUBMIT_STEP_DETAILS = step =>
    `${API_HOST}/panel/api/v1/spg/merchant/submit/bd/${step}`;
export const API_ADD_BD_ONBOARDING_MAKER = service =>
    `${API_HOST}/panel/api/v1/spg/${service}/add/request/maker`;

// Merchant OnboardStatus
export const API_MERCHANT_UPDATE_STATUS = `${API_HOST}/panel/api/v1/spg/fetch/merchant/updates/list`;

// Merchant Edit
export const API_GET_MERCHANT_INFO = `${API_HOST}/panel/api/v1/spg/entity/get/info`;
export const API_GET_TERMINAL_INFO = `${API_HOST}/panel/api/v1/spg/entity/get/info`;
export const API_FETCH_PG_CONFIG = `${API_HOST}/panel/api/v1/spg/v1/merchant/fetch/pg/config`;
export const API_FETCH_ROUTER_DETAILS = `${API_HOST}/panel/api/v1/spg/v1/merchant/fetch/routing`;
export const API_FETCH_SURCHARGE_DETAILS = `${API_HOST}/panel/api/v1/spg/fetch/feeInfo`;
export const API_UPDATE_MERCHANT = `${API_HOST}/panel/api/v1/spg/merchant/update/entity`;
export const API_UPDATE_PG_CONFIG = `${API_HOST}/panel/api/v1/spg/v2/merchant/update/pg/config`;
export const API_UPDATE_SETTLEMENT = `${API_HOST}/panel/api/v1/spg/update/settlementdata`;
export const API_FETCH_BASIC_DATA = `${API_HOST}/panel/api/v1/spg/fetch/basic/formdata`;
export const API_UPDATE_ROUTING = `${API_HOST}/panel/api/v1/spg/merchant/update/routing`;
export const API_UPDATE_SURCHARGE = `${API_HOST}/panel/api/v1/spg/update/feeInfo`;
export const API_UPDATE_SECTIONS = `${API_HOST}/panel/api/v1/spg/merchant/update/sectiondetails`;
export const API_FETCH_SECTIONS = `${API_HOST}/panel/api/v1/spg/merchant/fetch/merchant/config`;

// KYC Section data
export const API_UPLOAD_KYC_DOCUMENT = `${API_HOST}/panel/api/v1/spg/merchant/kyc/documents/upload`;
export const API_VIEW_KYC_DOCUMENT = `${API_HOST}/panel/api/v1/spg/merchant/kyc/documents/view`;

// Transaction View
export const API_FETCH_TRANSACTION = `${API_HOST}/panel/api/v1/spg/thv/filtered/txn`;
export const API_FETCH_UNDERLYING_MERCHANTS = `${API_HOST}/panel/api/v1/spg/merchant/underlying/merchants`;
export const API_INITIATE_REFUND = `${API_HOST}/panel/api/v1/spg/initiate/refund`;
export const API_GENERATE_REPORT = `${API_HOST}/panel/api/v1/spg/thv/txns/reports`;
export const API_GENERATE_CHECKER_REPORT = `${API_HOST}/panel/api/v1/spg/reports/download/submit`;
export const API_GET_ACTIVE_REPORT = `${API_HOST}/panel/api/v1/spg/thv/txns/reports/active`;
export const API_GET_CHECKER_ACTIVE_REPORT = `${API_HOST}/panel/api/v1/spg/reports/active`;
export const API_DOWNLOAD_REPORT = `${API_HOST}/panel/api/v1/spg/thv/txns/reports/download`;
export const API_DOWNLOAD_CHECKER_REPORT = `${API_HOST}/panel/api/v1/spg/reports/download`;
export const API_TRANSACTION_STATUS = `${API_HOST}/panel/api/v1/spg/check/txn/status`;
export const API_FETCH_REFUND_TXN = `${API_HOST}/panel/api/v1/spg/refund/getRefundTransactionData`;

// Sample File
export const SAMPLE_FILE_DOWNLOAD = `${CDN_HOST}/assets/files/Sample-Bin-Upload.csv`;

// Manage Bin
export const API_FETCH_BIN_RECENT = `${API_HOST}/panel/api/v1/spg/merchant/file/process/status`;
export const API_BIN_UPLOAD_FILE = `${API_HOST}/panel/api/v1/spg/merchant/bin/file/upload`;
export const API_NETWORK_BIN_UPLOAD_FILE = `${API_HOST}/panel/api/v1/spg/issuer/bin/file/upload`;

export const API_DOWNLOAD_BY_REQUEST = `${API_HOST}/panel/api/v1/spg/merchant/download/bin/file`;
export const API_SEARCH_BIN_DETAIL = `${API_HOST}/panel/api/v1/spg/merchant/search/bin/detail`;
export const API_BIN_UPDATE_DETAIL = `${API_HOST}/panel/api/v1/spg/merchant/update/bin/detail`;
export const API_RECENT_SEARCH = `${API_HOST}/panel/api/v1/spg/recent/bin/head/search`;
export const API_STATIC_DATA = `${API_HOST}/panel/api/v1/spg/merchant/bin/card/static/detail`;

// Comm Profile
export const API_FETCH_NOTIFICATION_EVENTS = `${API_HOST}/panel/api/v1/spg/merchant/notificationevents/fetch`;
export const API_ADD_COMM_PROFILE = `${API_HOST}/panel/api/v1/spg/merchant/profile/add`;
export const API_FETCH_COMM_PROFILE = `${API_HOST}/panel/api/v1/spg/merchant/profile/fetch`;
export const API_UPDATE_COMM_PROFILE = `${API_HOST}/panel/api/v1/spg/merchant/profile/update`;

// Otp Management
export const API_OTP_RESEND = `${API_HOST}/panel/api/v1/spg/otp/resend`;
export const API_OTP_VALIDATE = `${API_HOST}/panel/api/v1/spg/otp/validate/login`;

// Profile
export const API_FETCH_MERCHANT_PROFILE = `${API_HOST}/panel/api/v1/spg/merchant/logo/get`;
export const API_UPDATE_PROFILE = `${API_HOST}/panel/api/v1/spg/merchant/logo/update`;
export const API_CREATE_STATIC_QR = `${API_HOST}/panel/api/v1/spg/merchant/generate/qr`;
export const API_DELETE_PROFILE = `${API_HOST}/panel/api/v1/spg/merchant/logo/delete`;
export const API_SDK_JSON = `${CDN_HOST}/assets/sdks/sdk-info.json`;

// Audit Trail
export const API_AUDIT_TRAIL_STATIC = `${API_HOST}/panel/api/v1/spg/static/audit/event/action`;
export const API_AUDIT_TRAIL_FETCH = `${API_HOST}/panel/api/v1/spg/audit/event`;

// DashBoard
export const API_FETCH_MIXED_GRAPH = `${API_HOST}/panel/api/v1/spg/dashboard/graph/multi/mixed`;
export const API_FETCH_MULTI_GRAPH = `${API_HOST}/panel/api/v1/spg/dashboard/graph/multi/table`;
export const API_FETCH_SINGLE_GRAPH = `${API_HOST}/panel/api/v1/spg/dashboard/graph/single/time`;
export const API_FETCH_SUMMARY_GRAPH = `${API_HOST}/panel/api/v1/spg/dashboard/summary`;
export const API_HIERARCHY_LIST_MULTI = `${API_HOST}/panel/api/v1/spg/entity/list/hierarchy`;

// Payment Links
export const API_FETCH_PAY_DATA = `${API_HOST}/panel/api/v1/spg/paylink/data/getAll`;
export const API_CREATE_PAY_LINK = `${API_HOST}/panel/api/v1/spg/paylink/data/create`;
export const API_UPDATE_PAY_LINK = `${API_HOST}/panel/api/v1/spg/paylink/data/update`;
export const API_SHARE_PAY_LINK = `${API_HOST}/panel/api/v1/spg/paylink/share`;
export const API_RESHARE_PAY_LINK = `${API_HOST}/panel/api/v1/spg/paylink/reshare`;
export const API_LIST_PAY_TRANSACTIONS = `${API_HOST}/panel/api/v1/spg/paylink/getAllTxns`;
export const API_PAY_LINK_SUMMARY = `${API_HOST}/panel/api/v1/spg/paylink/getSummary`;
export const API_MERCHANT_TEMPLATE_DETAILS = `${API_HOST}/panel/api/v1/spg/paylink/template`;

// Settlement
export const API_SETTLEMENT_LISTING = `${API_HOST}/panel/api/v1/spg/settlement/filtered/txn`;
export const API_RETRY_SETTLEMENT = `${API_HOST}/panel/api/v1/spg/settlement/retry`;
export const API_RETRIGGER_SETTLEMENT = `${API_HOST}/panel/api/v1/spg/settlement/repeat`;
export const API_FETCH_AVAILABLE_BALANCE = `${API_HOST} /panel/api/v1/spg/fetch/available/balance`;
export const API_FETCH_ODS_FEE_DETAILS = `${API_HOST} /panel/api/v1/spg/fetch/ods/fee/details`;
export const API_PROCESS_ODS = `${API_HOST} /panel/api/v1/spg/process/ods`;
export const API_FETCH_NET_SETTLEMENT = `${API_HOST}/panel/api/v1/spg/v1/settlement-stats`;


// checkout customization
export const API_ADD_CHECKOUT_CUSTOMIZATION = `${API_HOST}/panel/api/v1/spg/merchant/theme/submit`;
export const API_ADD_CHECKOUT_CUSTOMIZATION_CUSTOM_DETAILS = `${API_HOST}/panel/api/v1/spg/merchant/custom/checkout/update`;
export const API_GET_CHECKOUT_CUSTOMIZATION = `${API_HOST}/panel/api/v1/spg/merchant/theme/get`;
export const API_UPDATE_CHECKOUT_CUSTOMIZATION = `${API_HOST}/panel/api/v1/spg/merchant/update/entity`;
// MERCHANT ADJUSTMENT
export const API_FETCH_MERCHANT_ADJUSTMENTS = `${API_HOST}/panel/api/v1/spg/merchantAdjustment/filtered/txn`;
export const API_CREATE_MERCHANT_ADJUSTMENTS = `${API_HOST}/panel/api/v1/spg/create/merchantAdjustment`;
export const API_GENERATE_ADJUSTMENT_REPORT = `${API_HOST}/panel/api/v1/spg/thv/merchantadjustment/txns/reports`;

// Bulk Upload
export const API_FETCH_BULK_UPLOAD_RECENT = `${API_HOST}/panel/api/v1/spg/bulkrefund/file/process/status`;
export const API_FETCH_BULK_UPLOAD_PREFILLED_FILE = `${API_HOST}/panel/api/v1/spg/bulkrefund/prefilled/file`;
export const API_BULK_UPLOAD_FILE = `${API_HOST}/panel/api/v1/spg/merchant/bulkrefund/file/upload`;
export const API_BULK_UPLOAD_FILE_TRANSACTION_VIEW = `${API_HOST}/panel/api/v1/spg/bulkrefund/file/txn/status`;
export const API_BULK_UPLOAD_DOWNLOAD_FILE = `${API_HOST}/panel/api/v1/spg/merchant/download/bulkrefund/file`;
export const API_BULK_TERMINAL_ID_UPLOAD_FILE = `${API_HOST}/panel/api/v1/spg/files/upload`;
export const API_BULK_TERMINAL_ID_DOWNLOAD_FILE = `${API_HOST}/panel/api/v1/spg/terminal/bulk/download/submit`;
export const API_BULK_TERMINAL_ID_GENERATE_REPORT = `${API_HOST}panel/api/v1/spg/reports/download/submit`;

// Invoice
export const API_INVOICE_LIST_DETAILS = `${API_HOST}/panel/api/v1/spg/merchant-invoice/v1/fetch/info`;
export const API_INVOICE_GENERATE_REPORT = `${API_HOST}/panel/api/v1/spg/merchant-invoice/v1/generate/reports`;
export const API_INVOICE_GENERATE_INVOICE = `${API_HOST}/panel/api/v1/spg/merchant-invoice/v1/generate/invoice`;
export const API_UPDATE_INVOICE_PAYMENT_STATUS = `${API_HOST}/panel/api/v1/spg/merchant-invoice/update/paymentstatus`;

// bulk payment link
export const API_DOWNLOAD_BULK_PAYMENT_LINK_PRE_FILLED_FILE = `${API_HOST}/panel/api/v1/spg/bulkpaylink/prefilled/file`;
export const API_FETCH_RECENT_BULK_PAYMENT_LINK = `${API_HOST}/panel/api/v1/spg/bulkpaylink/file/process/status`;
export const API_UPLOAD_BULK_PAYMENT_LINK_FILE = `${API_HOST}/panel/api/v1/spg/merchant/bulkpaylink/file/upload`;
export const API_DOWNLOAD_BULK_PAYMENT_LINK_FILE = `${API_HOST}/panel/api/v1/spg/merchant/download/bulkpaylink/file`;

// bulk account verification
export const API_DOWNLOAD_BULK_ACCOUNT_VERIFICATION_PRE_FILLED_FILE = `${API_HOST}/panel/api/v1/spg/bulk/account/verification/prefilled/file`;
export const API_FETCH_STATUS_BULK_ACCOUNT_VERIFICATION = `${API_HOST}/panel/api/v1/spg/bulk/account/verification/file/process/status`;
export const API_UPLOAD_BULK_ACCOUNT_VERIFICATION_FILE = `${API_HOST}/panel/api/v1/spg/merchant/bulk/account/verification/file/upload`;
export const API_DOWNLOAD_BULK_ACCOUNT_VERIFICATION_FILE = `${API_HOST}/panel/api/v1/spg/merchant/download/bulk/account/verification/file`;

// MAKER PANEL
export const API_FETCH_MAKER_LIST = `${API_HOST}/panel/api/v1/spg/maker/get/add/request`;
export const API_FETCH_CHECKER_LIST = `${API_HOST}/panel/api/v1/spg/checker/get/add/request`;
export const API_UPDATE_MAKER_REQUEST = `${API_HOST}/panel/api/v1/spg/maker/update/request`;
export const API_GENERATE_MAKER_REPORT = `${API_HOST}/panel/api/v1/spg/reports/download/submit`
export const API_DOWNLOAD_MAKER_REPORT = `${API_HOST}/panel/api/v1/spg/reports/download`;
export const API_GET_MAKER_ACTIVE_REPORT = `${API_HOST}/panel/api/v1/spg/reports/active`;

//     export const API_ADD_MAKER_REQUEST = service =>
//     `${API_HOST}/panel/api/v1/spg/${service}/add/request/maker`;
// export const API_UPDATE_MAKER_REQUEST = `${API_HOST}/panel/api/v1/spg/maker/update/request`;

export const API_GET_ACTIVE_REPORT_CUSTOM = RequestType =>
    `${API_HOST}/panel/api/v1/spg/thv/txns/reports/active?reportType=${RequestType}`;

export const API_GET_ACTIVE_CHECKER_REPORT_CUSTOM = RequestType =>
    `${API_HOST}/panel/api/v1/spg/reports/active?reportType=${RequestType}`; 

export const API_GET_ACTIVE_MAKER_REPORT_CUSTOM = RequestType =>
    `${API_HOST}/panel/api/v1/spg/reports/active?reportType=${RequestType}`; 

export const API_GET_ACTIVE_TERMINAL_ONBOARDING_REPORT_CUSTOM = RequestType =>
    `${API_HOST}/panel/api/v1/spg/reports/active?reportType=${RequestType}`;

export const API_GET_STATIC_DATA = RequestType =>
    `${API_HOST}/panel/api/v1/spg/static/data?screenType=${RequestType}`;
// MANDATES PANEL
/**
 * API endpoint for fetching mandates.
 * @const {string}
 */
export const API_FETCH_MANDATES = `${API_HOST}/panel/api/spg/filtered/mandates`;

/**
 * API endpoint for getting active report mandates.
 * @const {string}
 */
export const API_GET_ACTIVE_REPORT_MANDATE = `${API_HOST}/panel/api/v1/spg/v1/txns/reports/active`;

/**
 * API endpoint for fetching mandate transactions.
 * @const {string}
 */
export const API_FETCH_MANDATE_TRANSACTIONS = `${API_HOST}/panel/api/spg/mandates/txns`;

/**
 * API endpoint for updating mandates.
 * @const {string}
 */
export const API_UPDATE_MANDATE = `${API_HOST}/panel/api/spg/modify/mandates`;

// Chargeback
export const API_CHARGEBACK_STATIC_DATA = `${API_HOST}/panel/api/spg/static/chargeback/data`;

export const API_FETCH_CHARGEBACK_DATA = `${API_HOST}/panel/api/spg/get/chargeback/list`;

export const API_FETCH_CHAREGEBACK_DETAILS = `${API_HOST}/panel/api/spg/get/detailed/chargeback`;

export const API_VALIDATE_CHARGEBACK = `${API_HOST}/panel/api/spg/validate/chargeback`;

export const API_RAISE_CHARGEBACK = `${API_HOST}/panel/api/spg/raise/chargeback`;

export const API_CHARGEBACK_AGENT_ACTION = `${API_HOST}/panel/api/spg/chargeback/agent/action`;

export const API_CHARGEBACK_MERCHANT_ACTION = `${API_HOST}/panel/api/spg/chargeback/merchant/action`;

export const API_GET_ACTIVE_REPORT_CHARGEBACK = `${API_HOST}/panel/api/v1/spg/v1/txns/reports/active`;

// payment gateway credentials
export const API_FETCH_PAYMENT_GATEWAY_CREDENTIAL = `${API_HOST}/panel/api/v1/spg/pg/credentials/fetch`;

export const API_CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP = step =>
    `${API_HOST}/panel/api/v1/spg/pg/${step}/create`;

export const API_UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP = step =>
    `${API_HOST}/panel/api/v1/spg/pg/${step}/update`;

export const API_FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA = `${API_HOST}/panel/api/v1/spg/pg/credentials/details/fetch`;

// comman routes
export const API_GET_ACTIVE_REPORTS = `${API_HOST}/panel/api/v1/spg/v1/txns/reports/active`;
export const API_CHECK_DISPUTE_STATUS = `${API_HOST}/panel/api/spg/dispute/status`;
export const API_REFUND_DISPUTE = `${API_HOST}/panel/api/v1/spg/initiate/refund`;
// New API created
//export const API_GET_HEADER =`${API_HOST}/panel/api/v1/spg/initiate/refund`;

//TERMINAL ID
export const API_CREATE_TID_REQUEST = `${API_HOST}/panel/api/v1/spg/merchant/add/request/maker`;
export const API_FETCH_STATIC_URL = `${API_HOST}/panel/api/v1/spg/v2/merchant/generate/qr`;
export const API_BULK_UPLOAD_TERMINAL_ID = `${API_HOST}/panel/api/v1/spg/terminal/update/file/upload`;
export const API_DOWNLOAD_TERMINAL_ONBOARDING_REPORT = `${API_HOST}/panel/api/v1/spg/reports/download`;
export const API_UPLOAD_BULK_TERMINAL_ID = `${API_HOST}/panel/api/v1/spg/bulk/terminal/file/upload`;
export const API_BULK_TERMINAL_ID_UPLOAD_STATUS = `${API_HOST}/panel/api/v1/spg/bulkterminal/file/process/status`;
export const API_BULK_TERMINAL_ID_UPLOAD_DOWNLOAD = `${API_HOST}/panel/api/v1/spg/reports/download`

// mob phase 2
export const API_UPLOAD_AND_FETCH_OCR = `${API_HOST}/panel/api/v1/spg/doc/uploadAndFetch`;
export const API_VERIFY_PII_ACCOUNT_DETAILS = `${API_HOST}/panel/api/v1/spg/account/verify`;

// PAYMENT PAGE
export const FETCH_PAYMENT_PAGE_DATA = `${API_HOST}/panel/api/v1/spg/formlink/v1/get/data`;
export const API_LIST_PAY_TRANSACTIONS_PAYMENT_PAGE = `${API_HOST}/panel/api/v1/spg/formlink/v1/get/txn`;
export const API_CREATE_PAYMENT_PAGE = `${API_HOST}/panel/api/v1/spg/payment/form/create`;
export const API_GET_PAYMENT_PAGE_DETAILS = `${API_HOST}/panel/api/v1/spg/payment/form/get`;
export const API_UPDATE_PAYMENT_PAGE_DETAILS = `${API_HOST}/panel/api/v1/spg/payment/form/update`;

// UPDATE BIN APIS
export const UPDATE_BIN = `${API_HOST}/panel/api/v1/spg/merchant/bin/mapping/update`;
export const GET_BIN_VALUES = `${API_HOST}/panel/api/v1/spg/merchant/bin/mapping`;